











import { defineComponent, PropType, ref } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { InputSubscriptionLevelCreate } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import PriceLevelEditForm from "./PriceLevelEditForm.vue";

export default defineComponent({
  name: "CreateLevelView",
  components: { PriceLevelEditForm, ModalView, PageTitle, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
    userId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({
      pricePackageId: props.paymentPackages[0].id,
      description: "",
      title: undefined,
    });

    const create = () => {
      const data: InputSubscriptionLevelCreate = {
        pricePackageId: values.value.pricePackageId,
        description: values.value.description || "",
        title: values.value.title,
        userId: props.userId,
      };
      emit("create", data);
    };

    return {
      values,
      create,
    };
  },
});
